import { StylizedCardItemLinkWithIcon } from 'src/app/components/Elements/Card/StylizedCardItemLinkWithIcon';
import * as paths from 'src/app/router/paths';
import type { CheckoutPickupSectionProps, DeliveryMethod } from 'src/app/types';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { DeliveryAddressFooterText } from '../styles';

interface CheckoutDeliveryMethodSectionProps extends CheckoutPickupSectionProps {
  addressPath: string;
  bffCartDeliveryMethod: DeliveryMethod;
  deliveryAddressFirstRowText: string;
  deliveryAddressSecondRowText: string;
  isUserESIMailEligible: boolean;
  shouldShowDoormanText: boolean;
  instructions: string;
  hasChosenDeliveryAfterSettingDeliveryMethodAsPickupStation: boolean;
  hasChosenDeliveryAddressButNotDeliveryMethod: boolean;
  hasError: boolean;
}

const addressErrorText = `• Missing Address`;
const deliveryMethodErrorText = `• No Delivery Time Chosen`;

export const CheckoutDeliveryMethodSection = ({
  addressPath,
  bffCartDeliveryAddress,
  cartId,
  deliveryMethodFirstRowText,
  deliveryMethodSecondRowText,
  deliveryAddressFirstRowText,
  deliveryAddressSecondRowText,
  dispatchAddressListClicked,
  dispatchDeliveryWindowsListClicked,
  hasChosenDeliveryAddressButNotDeliveryMethod,
  hasChosenDeliveryAfterSettingDeliveryMethodAsPickupStation,
  isUserESIMailEligible,
  shouldShowDoormanText,
  instructions,
  hasError,
}: CheckoutDeliveryMethodSectionProps) => {
  return (
    <>
      <StylizedCardItemLinkWithIcon
        sectionTitle={hasError && !bffCartDeliveryAddress ? addressErrorText : 'Address'}
        capsuleIcon={CAPSULE_ICON_STRINGS.checkout_address}
        to={addressPath}
        ariaLabel={'Choose or Add Delivery Address'}
        handleOnClick={dispatchAddressListClicked}
        dataCy={'checkout-address'}
        textList={
          hasChosenDeliveryAfterSettingDeliveryMethodAsPickupStation
            ? ['Add delivery address']
            : [deliveryAddressFirstRowText, deliveryAddressSecondRowText]
        }
        isDisabled={false}
        disabledText={'Add delivery address'}
        footerMessage={
          <>
            {shouldShowDoormanText && <DeliveryAddressFooterText>{'Leave with doorman'}</DeliveryAddressFooterText>}
            {instructions && <DeliveryAddressFooterText>{instructions}</DeliveryAddressFooterText>}
          </>
        }
        hasError={hasError && !bffCartDeliveryAddress}
      />
      <StylizedCardItemLinkWithIcon
        sectionTitle={
          hasError && hasChosenDeliveryAddressButNotDeliveryMethod ? deliveryMethodErrorText : 'Free Delivery'
        }
        capsuleIcon={CAPSULE_ICON_STRINGS.checkout_delivery}
        to={
          isUserESIMailEligible
            ? paths.checkoutSelectDeliveryMethod.toPath({ cartId })
            : paths.checkoutSelectWindow.toPath({ cartId })
        }
        ariaLabel={'Choose Delivery Time'}
        handleOnClick={dispatchDeliveryWindowsListClicked}
        dataCy={'checkout-delivery-windows'}
        textList={
          hasChosenDeliveryAfterSettingDeliveryMethodAsPickupStation
            ? ['Choose delivery time']
            : [deliveryMethodFirstRowText, deliveryMethodSecondRowText]
        }
        isDisabled={!bffCartDeliveryAddress}
        disabledText={'Choose delivery time'}
        // We only bold the text when the delivery time has already been chosen
        shouldBoldFirstText={
          !hasChosenDeliveryAddressButNotDeliveryMethod && !hasChosenDeliveryAfterSettingDeliveryMethodAsPickupStation
        }
        hasError={hasError && hasChosenDeliveryAddressButNotDeliveryMethod}
      />
    </>
  );
};
